<script>
import dataTablesComponent from "@/components/subcomponents/dataTablesComponent.vue";
import {jsPDF} from "jspdf";
import html2canvas from 'html2canvas';

export default {
  name: "amhInvoiceGenerationForm",
  inject: ['$axios', '$_', '$apiBaseURL', '$appVer', '$DateTime', '$formatNumber'],
  props: {loginData: Object},
  data() {
    let vm = this;
    let placeholdersBaseUrl;
    if (location.host === 'safeapp.myamh.org') {
      placeholdersBaseUrl = 'https://safeappnode.myamh.org';
    } else {
      placeholdersBaseUrl = 'https://safedevnode.myamh.org';
    }
    return {
      placeholdersBaseUrl: placeholdersBaseUrl,
      filterForPartner: '',
      partnerShortName: '',
      filterForPocket: '',
      filterForMonth: '',
      pockets: [
        {pocketid: 'pocketwatsi', pocket_name: 'Watsi'},
        {pocketid: 'pocketamhecs', pocket_name: 'AMH ECS'},
        {pocketid: 'pocketamhsdv', pocket_name: 'AMH SVD'},
        {pocketid: 'pocketcontingency', pocket_name: 'Contingency'},
        {pocketid: 'pocketamhother', pocket_name: 'AMH Other'},
        {pocketid: 'pocketunallocated', pocket_name: 'Unallocated'},
      ],
      drawTime: vm.$DateTime.local().setZone('utc').toUnixInteger(),
      financeReportsGroup_partner_pocket: {partnername: false, p_approvalpocket: false},
      financeReportsPocketData: {
        pocketamhecs: false,
        pocketamhother: false,
        pocketamhsdv: false,
        pocketcontingency: false,
        pocketunallocated: false,
        pocketwatsi: false
      },
      financeReportsPocketName: {
        pocketamhecs: 'AMH ECS',
        pocketamhother: 'AMH Other',
        pocketamhsdv: 'AMH SVD',
        pocketcontingency: 'AMH Contingency',
        pocketunallocated: 'Unallocated',
        pocketwatsi: 'Watsi',
        unknown: 'Unknown'
      },
      rowSelectedCheck: {},
      safeAskCount: 0,
      safeAskTotal: vm.returnInvoiceUSD('USD', 0),
      invoiceCurrencies: [],
      allItemsChecked: '',
      invoiceAddingTime: 0,
      previewInvoiceRows: [],
      previewInvoiceRowsTotal: 0,

      invoiceSelectionTab: 1,
      progressValue: 0,
      caseIdAccYear: [],
      showProgress: false,
      invoiceUploadedstatus: 0,

      invoiceTimeLimit: true,

      generateInvoiceFromServerStatus: false,
      generateInvoiceFromServer: '',
      tabledCasesObj: {},
      selectedCasesObj: {}
    }
  },
  components: {
    dataTablesComponent
  },
  methods: {
    invoiceDateSelected: function () {
    },
    tableToRefresh: function () {
    },
    updateTotalRecords: function () {
    },
    returnInvoiceUSD: function (currency, numbers) {
      let vm = this,
          floatValue = (Math.round(numbers * 100) / 100).toFixed(2);
      return vm.$formatNumber({
        prefix: `${currency} `,
        round: 2
      })(floatValue, {noSeparator: false});
    },
    previewSummaries: function (previewSummaries) {
      console.log(previewSummaries);
      let vm = this,
          casesTabled = {};
      vm.$_.forEach(previewSummaries.allCaseIds, function (caseId, caseIdIndex) {
        if (typeof vm.rowSelectedCheck[caseId] === 'undefined') {
          vm.rowSelectedCheck[caseId] = true;
        }
        casesTabled[caseId] = previewSummaries.allCaseIdSafeAsks[caseIdIndex];
      });
      vm.safeAskCount = previewSummaries.safeAsk.count;
      vm.safeAskTotal = vm.returnInvoiceUSD('USD', previewSummaries.safeAsk.total);
      vm.invoiceCurrencies = [];
      vm.$_.forEach(previewSummaries.invoice, function (currencyObject, currencyName) {
        vm.invoiceCurrencies.push(`${currencyName} (${currencyObject.count})`);
        vm.invoiceCurrencies.push(vm.returnInvoiceUSD(currencyName, currencyObject.total));
      });
      vm.tabledCasesObj = vm.$_.assign({}, casesTabled);
      vm.selectedCasesObj = {};
      vm.$_.forEach(vm.rowSelectedCheck, function (caseSelected, caseId) {
        if (caseSelected) {
          if (typeof vm.tabledCasesObj[caseId] !== 'undefined') {
            vm.selectedCasesObj[caseId] = vm.tabledCasesObj[caseId];
          }
        }
      });
      console.log(vm.selectedCasesObj);
    },
    selectedInvoiceRows: function (selectedInvoiceRows) {
      console.log(selectedInvoiceRows);
      let vm = this;
      vm.previewInvoiceRows = selectedInvoiceRows.selectedRows;
      vm.previewInvoiceRowsTotal = vm.returnInvoiceUSD('USD', selectedInvoiceRows.totalUSD);
      vm.invoiceSelectionTab = 2;
      vm.caseIdAccYear = selectedInvoiceRows.caseIdAccYear;
    },
    toggleSelectedCaseCheck: function (toggleSelectedCaseCheck) {
      console.log(toggleSelectedCaseCheck);
      let vm = this,
          rowCheckId;
      if (toggleSelectedCaseCheck === 'all') {
        vm.$_.forEach(vm.rowSelectedCheck, function (caseId, caseIdIndex) {
          rowCheckId = `select_case_${caseIdIndex}`;
          vm.rowSelectedCheck[caseIdIndex] = document.getElementById("select_case_all").checked;
          document.getElementById(rowCheckId).checked = document.getElementById("select_case_all").checked;
        });
      } else {
        vm.rowSelectedCheck[toggleSelectedCaseCheck] = !vm.rowSelectedCheck[toggleSelectedCaseCheck];
      }

      console.log(vm.rowSelectedCheck);
      console.log(vm.previewInvoiceRows);
      console.log(vm.previewInvoiceRowsTotal);

      // vm.selectedCasesObj = {};
      // vm.$_.forEach(vm.rowSelectedCheck, function (caseSelected, caseId) {
      //   if (caseSelected) {
      //     vm.selectedCasesObj[caseId] = vm.tabledCasesObj[caseId];
      //   }
      // });
      // console.log(vm.selectedCasesObj);

    },
    addCasesToInvoice: function () {
      let vm = this;
      if (vm.invoiceSelectionTab !== 1) {
        vm.invoiceSelectionTab = 1;
      }
      vm.invoiceAddingTime = vm.$DateTime.local().setZone('utc').toUnixInteger();
      vm.invoiceUploadedstatus = 0;
      vm.generateInvoiceFromServerStatus = false;

      let invoiceNumberComputed = vm.computeInvoiceNumber;
      console.log(invoiceNumberComputed);

      vm.$axios.post('/profile/action/assignInvoiceNumber', {
        timezone: vm.currentData.country_tz,
        repData: vm.currentData,
        invoiceNumberComputed: invoiceNumberComputed
      }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${vm.currentData.token}`
        }
      })
          .then(function (response) {
            console.log(response.data);
            if (response.data.success === 'true') {
              vm.generateInvoiceFromServer = response.data.invoiceNumber;
              vm.generateInvoiceFromServerStatus = true;
            }
          });

    },
    sendAmhInvoiceToServer: function (blobFile) {
      let vm = this;
      let data = new FormData();
      data.append('invoiceGenerated', blobFile);
      data.append('fileType', blobFile.type);
      data.append('caseIdAccYear', vm.caseIdAccYear);
      data.append('computeInvoiceNumber', vm.computeInvoiceNumber);
      data.append('generatedInvoiceNumber', vm.generateInvoiceFromServer);
      data.append('computeInvoicePeriod', vm.computeInvoicePeriod);
      data.append('computeInvoiceDate', vm.computeInvoiceDate);
      data.append('previewInvoiceRowsTotal', vm.previewInvoiceRowsTotal);
      data.append('coordData', JSON.stringify(vm.currentData));
      let config = {
        onUploadProgress: function (progressEvent) {
          vm.progressValue = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }
      };
      vm.showProgress = true;
      let dataTs = vm.$DateTime.local().setZone('UTC').toUnixInteger();

      vm.$axios.post(`/profile/mediaUploading/amhInvoiceGenerated/${dataTs}/add/amhInvoiceAttachment`, data, config)
          .then(function (res) {
            if (res.data.success) {
              vm.progressValue = 100;
              vm.showProgress = false;
              vm.invoiceUploadedstatus = 2;
            }
          })
          .catch(function (err) {
            console.error(err);
            vm.showProgress = false;
            vm.invoiceUploadedstatus = 3;
          });
    },
    downloadPreviewedInvoice: function (invoiceTarget) {
      let vm = this,
          blobFile;
      vm.showProgress = true;
      vm.progressValue = 0;
      try {
        vm.invoiceUploadedstatus = 1;
        html2canvas(document.getElementById('invoicePreviewForAmhInvoice'),
            {
              logging: true,
              useCORS: true,
              taintTest: false,
              scale: 1
            })
            .then(function (canvas) {

              const A4_HEIGHT = 841.89;
              const A4_WIDTH = 595.28;
              const WIDTH_MARGIN = 10;
              const HEIGHT_MARGIN = 10;
              const PAGE_HEIGHT = A4_HEIGHT - 2 * HEIGHT_MARGIN;
              const pdf = new jsPDF('p', 'pt', 'a4');
              const canvasWidth = canvas.width;
              const canvasHeight = canvas.height;
              const imgWidth = A4_WIDTH - 2 * WIDTH_MARGIN;
              const imgHeight = (imgWidth / canvasWidth) * canvasHeight;
              const pageImg = canvas.toDataURL('image/png', 1.0);
              let position = HEIGHT_MARGIN;
              if (imgHeight > PAGE_HEIGHT) {
                let heightUnprinted = imgHeight;
                while (heightUnprinted > 0) {
                  pdf.addImage(pageImg, 'PNG', WIDTH_MARGIN, position, imgWidth, imgHeight);
                  pdf.setFillColor(255, 255, 255);
                  pdf.rect(0, 0, A4_WIDTH, HEIGHT_MARGIN, 'F');
                  pdf.rect(0, A4_HEIGHT - HEIGHT_MARGIN, A4_WIDTH, HEIGHT_MARGIN, 'F');
                  heightUnprinted -= PAGE_HEIGHT;
                  position -= PAGE_HEIGHT;
                  if (heightUnprinted > 0) pdf.addPage();
                }
              } else {
                pdf.addImage(pageImg, 'PNG', WIDTH_MARGIN, HEIGHT_MARGIN, imgWidth, imgHeight);
              }

              switch (invoiceTarget) {
                case 'download':
                  pdf.save('download.pdf');
                  vm.showProgress = false;
                  vm.invoiceUploadedstatus = 0;
                  break;
                case 'send':
                  blobFile = pdf.output('blob');
                  vm.sendAmhInvoiceToServer(blobFile);
                  break;
              }

            });
      } catch (error) {
        console.error(error);
        vm.showProgress = false;
        vm.invoiceUploadedstatus = 0;
      }
    },
    resetForm: function () {
      let vm = this;
      vm.invoiceUploadedstatus = 0;
      vm.safeAskCount = 0;
      vm.safeAskTotal = vm.returnInvoiceUSD('USD', 0);
      vm.rowSelectedCheck = {};
      vm.previewInvoiceRows = [];
      vm.previewInvoiceRowsTotal = 0;
      vm.invoiceSelectionTab = 1;
      vm.drawTime = vm.$DateTime.local().setZone('utc').toUnixInteger();
      vm.generateInvoiceFromServerStatus = false;
      vm.generateInvoiceFromServer = '';
      vm.tabledCasesObj = {};
      vm.selectedCasesObj = {};
    }
  },
  computed: {
    setDatePickerClassInvoiceDate: function () {
      return 'wrapper-custom';
    },
    invoiceDateConstrain: function () {
      let vm = this,
          partnerTimezone,
          activeData = null;


      partnerTimezone = vm.currentData.country_tz;
      activeData = vm.$DateTime.local().setZone(partnerTimezone);

      return {
        from: vm.isoToJSDate(activeData.toISO())
      }


    },
    allInputsSelected: function () {
      let vm = this;
      return vm.filterForPartner !== '' && vm.filterForPocket !== '' && vm.filterForMonth !== '';
    },
    createPreviewTableConfig: function () {
      let vm = this,
          columns = [
            {
              name: 'caseid', data: 'caseid', title: 'Case ID',
              render: function (data, type, row) {
                return `<a class="button is-success is-light" href="/caseview/${data}/financecase/${row.partnerid}/${row.recordyear}" target="_blank"><span>${data}</span> <span class="icon is-small"><i class="fas fa-arrow-up-right-from-square"></i></span></a>`;
              }
            },
            {
              name: 'caseid', data: 'caseid',
              orderable: false,
              title: `<div class="checkbox-wrapper-19"><input type="checkbox" id="select_case_all" onclick="toggleSelectedCaseCheck('all')" /><label for="select_case_all" class="check-box"></label></div>`,
              render: function (data) {
                let checkedText = '';
                if (typeof vm.rowSelectedCheck[data] !== 'undefined') {
                  if (vm.rowSelectedCheck[data]) {
                    checkedText = 'checked';
                  } else {
                    checkedText = '';
                  }
                } else {
                  checkedText = 'checked';
                  vm.rowSelectedCheck[data] = true;
                }
                return `<div class="checkbox-wrapper-19"><input type="checkbox" id="select_case_${data}" onclick="toggleSelectedCaseCheck(${data})" ${checkedText}/><label for="select_case_${data}" class="check-box"></label></div>`
              }
            },
            {name: 'p_name', data: 'p_name', title: 'Patient Name'},
            {name: 'p_inpatientnumber', data: 'p_inpatientnumber', title: 'in-patient Number'},
            {name: 'f_approvalsafeaskamount', data: 'f_approvalsafeaskamount', title: 'Safe Ask (USD)'},
            {name: 'f_approvalsurgeryperformed', data: 'f_approvalsurgeryperformed', title: 'Surgery Performed'},
            {name: 'f_surgeryfrom', data: 'f_surgeryfrom', title: 'Surgery From'},
            {name: 'surgeryperformancedate', data: 'surgeryperformancedate', title: 'Surgery Date'},
            {name: 'prt_inv_number', data: 'prt_inv_number', title: 'Invoice Number'},
          ],
          tableData = [];
      return {columns: columns, data: tableData, currentData: vm.currentData};
    },
    financeReportsPocket: function () {
      let vm = this,
          returnObject = {};
      vm.$_.forEach(vm.financeReportsPocketData, function (financeReportsPocketDataValue, financeReportsPocketDataKey) {
        returnObject[financeReportsPocketDataKey] = financeReportsPocketDataKey === vm.filterForPocket;
      });
      return returnObject;
    },
    financeReportsYear: function () {

      let vm = this;
      if (vm.filterForMonth === 'all') {
        return {month: 'all', year: 'all'};
      } else {
        let yearKey = `year${vm.$DateTime.fromISO(vm.filterForMonth.toISOString()).toFormat('yyyy')}`,
            monthNumber = `${vm.$DateTime.fromISO(vm.filterForMonth.toISOString()).toFormat('LL')}`,
            yearObject = {};
        yearObject[yearKey] = true;
        return {month: monthNumber, year: yearObject};
      }
    },
    computeInvoiceNumber: function () {
      let vm = this,
          invoiceNumberPrefix,
          pocketNameForInvoice,
          computeInvoiceNumberValue;
      if (vm.filterForMonth === '') {
        computeInvoiceNumberValue = '';
      } else {
        let yearKey, monthNumber;
        if (vm.filterForMonth === 'all') {
          let partnerTimezone;
          partnerTimezone = vm.currentData.country_tz;
          yearKey = `${vm.$DateTime.local().setZone(partnerTimezone).toFormat('yyyy')}`;
          monthNumber = `${vm.$DateTime.local().setZone(partnerTimezone).toFormat('LL')}`;
          invoiceNumberPrefix = `A`;
        } else {
          yearKey = `${vm.$DateTime.fromISO(vm.filterForMonth.toISOString()).toFormat('yyyy')}`;
          monthNumber = `${vm.$DateTime.fromISO(vm.filterForMonth.toISOString()).toFormat('LL')}`;
          invoiceNumberPrefix = `M`;
        }
        if (typeof vm.financeReportsPocketName[vm.filterForPocket] !== 'undefined') {
          pocketNameForInvoice = vm.financeReportsPocketName[vm.filterForPocket];
        } else {
          pocketNameForInvoice = vm.financeReportsPocketName['unknown'];
        }
        computeInvoiceNumberValue = `${vm.partnerShortName} ${pocketNameForInvoice}/${invoiceNumberPrefix}/${monthNumber}/${yearKey}`;
      }
      return computeInvoiceNumberValue;
    },
    computeInvoicePeriod: function () {
      let vm = this,
          computeInvoiceNumberValue;
      if (vm.filterForMonth === '') {
        computeInvoiceNumberValue = '';
      } else {
        if (vm.filterForMonth === 'all') {
          computeInvoiceNumberValue = `cases not invoiced`;
        } else {
          let yearKey = `${vm.$DateTime.fromISO(vm.filterForMonth.toISOString()).toFormat('yyyy')}`,
              monthNumber = `${vm.$DateTime.fromISO(vm.filterForMonth.toISOString()).toFormat('LL')}`;
          computeInvoiceNumberValue = `${monthNumber}-${yearKey}`;
        }
      }
      return computeInvoiceNumberValue;
    },
    computeInvoiceDate: function () {
      let vm = this,
          partnerTimezone,
          zonedDate = '';
      partnerTimezone = vm.currentData.country_tz;
      zonedDate = vm.$DateTime.local().setZone(partnerTimezone).toFormat(`dd LLL yyyy`)
      return zonedDate;
    },
    invoiceHasRecords: function () {
      let vm = this;
      return vm.selectedCasesCount > 0;
    },
    selectedCasesCount: function () {
      let vm = this;
      let selectedCasesCountResp = 0;
      vm.$_.forEach(vm.selectedCasesObj, function () {
        selectedCasesCountResp += 1;
      });
      return selectedCasesCountResp;
    },
    selectedCasesValue: function () {
      let vm = this;
      let selectedCasesValueResp = 0.00;
      vm.$_.forEach(vm.selectedCasesObj, function (caseValue) {
        selectedCasesValueResp += parseFloat(caseValue);
      });

      return vm.returnInvoiceUSD('USD', selectedCasesValueResp)
    }
  },
  mounted() {
    let vm = this;
    const storedAccount = localStorage.getItem("account");
    vm.currentData = JSON.parse(storedAccount);
    vm.filterForPartner = vm.currentData.partnerid;
    vm.partnerShortName = vm.currentData.partner_shortname;
  },
  created() {
    let vm = this;
    const storedAccount = localStorage.getItem("account");
    vm.currentData = JSON.parse(storedAccount);
    window.toggleSelectedCaseCheck = vm.toggleSelectedCaseCheck;
  },
  watch: {
    invoiceTimeLimit: {
      handler() {
        let vm = this;

        vm.safeAskCount = 0;
        vm.safeAskTotal = vm.returnInvoiceUSD('USD', 0);

        vm.generateInvoiceFromServerStatus = false;
        vm.generateInvoiceFromServer = '';
        vm.tabledCasesObj = {};
        vm.selectedCasesObj = {};

        if (!vm.invoiceTimeLimit) {
          vm.filterForMonth = 'all';
        } else {
          vm.filterForMonth = '';
        }
      },
      deep: true
    },
    filterForPocket: {
      handler() {
        let vm = this;

        if (vm.invoiceUploadedstatus !== 0 || vm.invoiceSelectionTab !== 1) {
          vm.filterForMonth = '';
          vm.resetForm();
        }

        if (vm.allInputsSelected) {
          vm.drawTime = vm.$DateTime.local().setZone('utc').toUnixInteger();
        }
      },
      deep: true
    },
    filterForMonth: {
      handler() {
        let vm = this;
        if (vm.invoiceUploadedstatus !== 0 || vm.invoiceSelectionTab !== 1) {
          vm.filterForPocket = '';
          vm.resetForm();
        }

        if (vm.allInputsSelected) {
          vm.drawTime = vm.$DateTime.local().setZone('utc').toUnixInteger();
        }
      },
      deep: true
    },
    rowSelectedCheck: {
      handler(newValue) {
        let vm = this;
        let allItemsCheckedTemp = 'checked';
        vm.$_.forEach(newValue, function (value) {
          if (!value) {
            allItemsCheckedTemp = '';
          }
        });


        vm.selectedCasesObj = {};
        vm.$_.forEach(vm.rowSelectedCheck, function (caseSelected, caseId) {
          if (caseSelected) {
            if (typeof vm.tabledCasesObj[caseId] !== 'undefined') {
              vm.selectedCasesObj[caseId] = vm.tabledCasesObj[caseId];
            }
          }
        });
        console.log(vm.selectedCasesObj);


        document.getElementById("select_case_all").checked = allItemsCheckedTemp === 'checked';

      },
      deep: true
    }
  }
}
</script>

<template>
  <div class="container-fluid box box-with-no-bg">
    <div class="columns is-multiline is-vcentered">
      <div
          class="column is-one-quarter-fullhd is-one-quarter-desktop is-full-tablet is-full-mobile top-align-content">
        <div class="columns is-multiline is-vcentered">
          <div class="column is-full">
            <label class="label has-text-centered">Pocket</label>
            <div class="field is-narrow">
              <div class="control">
                <div class="select is-rounded is-fullwidth partner-select">
                  <select v-model="filterForPocket">
                    <option value="">Please select pocket</option>
                    <option v-bind:value="pocket.pocketid" v-for="(pocket, index) in pockets" v-bind:key="index">
                      {{ pocket.pocket_name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-full">
            <label class="label has-text-centered invoice-period-select">
              <div class="switch-button">
                <input class="switch-button-checkbox" type="checkbox" v-model="invoiceTimeLimit"/>
                <label class="switch-button-label" for="">
                  <span class="switch-button-label-span">All</span></label>
              </div>
            </label>
            <div class="field is-narrow" v-if="invoiceTimeLimit">
              <div class="control">
                <datepicker v-model="filterForMonth"
                            name="invoiceMonth"
                            inline="true"
                            v-bind:disabled-dates="invoiceDateConstrain"
                            v-bind:input-class="'input-custom'"
                            v-bind:wrapper-class="setDatePickerClassInvoiceDate"
                            v-bind:calendar-class="'calendar-custom'"
                            v-bind:minimum-view="'month'"
                            v-bind:maximum-view="'month'"
                            v-on:selected="invoiceDateSelected">
                </datepicker>
              </div>
            </div>
          </div>

          <div class="column is-full">
            <label class="label has-text-centered">All Records Summary</label>
            <div class="columns is-multiline is-vcentered">
              <div
                  class="column is-half-fullhd is-half-desktop is-full-tablet is-full-mobile has-text-weight-semibold is-uppercase">
                Records
              </div>
              <div class="column is-half-fullhd is-half-desktop is-full-tablet is-full-mobile">{{ safeAskCount }}</div>
              <div
                  class="column is-half-fullhd is-half-desktop is-full-tablet is-full-mobile has-text-weight-semibold is-uppercase">
                SAFE ASK
              </div>
              <div class="column is-half-fullhd is-half-desktop is-full-tablet is-full-mobile">{{ safeAskTotal }}</div>
            </div>
          </div>

          <div class="column is-full">
            <label class="label has-text-centered">Selected Records Summary</label>
            <div class="columns is-multiline is-vcentered">
              <div
                  class="column is-half-fullhd is-half-desktop is-full-tablet is-full-mobile has-text-weight-semibold is-uppercase">
                Records
              </div>
              <div class="column is-half-fullhd is-half-desktop is-full-tablet is-full-mobile">{{
                  selectedCasesCount
                }}
              </div>
              <div
                  class="column is-half-fullhd is-half-desktop is-full-tablet is-full-mobile has-text-weight-semibold is-uppercase">
                SAFE ASK
              </div>
              <div class="column is-half-fullhd is-half-desktop is-full-tablet is-full-mobile">{{
                  selectedCasesValue
                }}
              </div>
            </div>
          </div>

          <div class="column is-full" v-if="invoiceUploadedstatus!==2">
            <label class="label has-text-centered">Preview</label>
            <div class="field is-narrow">
              <span class="preview-requirements"
                    v-bind:class="{'ok-to-proceed':filterForPocket!=='','nok-to-proceed':filterForPocket===''}">Pocket Selected</span>
              <span class="icon is-small">
                <i class="fas" v-bind:class="{'fa-check':filterForPocket!=='','fa-x':filterForPocket===''}"></i>
              </span>
            </div>
            <div class="field is-narrow">
              <span class="preview-requirements"
                    v-bind:class="{'ok-to-proceed':filterForMonth!=='','nok-to-proceed':filterForMonth===''}">Month Selected</span>
              <span class="icon is-small">
                <i class="fas" v-bind:class="{'fa-check':filterForMonth!=='','fa-x':filterForMonth===''}"></i>
              </span>
            </div>
            <div class="field is-narrow">
              <span class="preview-requirements"
                    v-bind:class="{'ok-to-proceed':invoiceHasRecords,'nok-to-proceed':!invoiceHasRecords}">Records Selected</span>
              <span class="icon is-small">
                <i class="fas" v-bind:class="{'fa-check':invoiceHasRecords,'fa-x':!invoiceHasRecords}"></i>
              </span>
            </div>
            <div class="field is-narrow" v-if="filterForPocket!=='' && filterForMonth!=='' && invoiceHasRecords">
              <div class="control">
                <button class="button is-success is-fullwidth" v-on:click="addCasesToInvoice()"
                        v-bind:disabled="invoiceUploadedstatus!==0 && invoiceUploadedstatus!==3">
                  <span>Generate Preview</span>
                  <span
                      class="icon is-small"><i class="fas fa-square-plus"></i></span></button>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div
          class="column is-three-quarters-fullhd is-three-quarters-desktop is-full-tablet is-full-mobile top-align-content a4-width-container">
        <div class="columns is-multiline is-vcentered">
          <div class="column is-full">
            <div class="tabs is-centered">
              <ul>
                <li v-bind:class="{'is-active':invoiceSelectionTab===1}" v-on:click="invoiceSelectionTab=1">
                  <a>Cases Selection</a>
                </li>
                <li v-if="allInputsSelected" v-bind:class="{'is-active':invoiceSelectionTab===2}"
                    v-on:click="invoiceSelectionTab=2">
                  <a>Invoice Preview</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="column is-full" v-if="invoiceSelectionTab===1">
            <dataTablesComponent
                ref="invoicedPreviewForAmhInvoice"
                v-bind:loginData="loginData"
                v-bind:tableData="createPreviewTableConfig"
                v-bind:drawTime="drawTime"
                v-bind:filterForPartner="filterForPartner"
                v-bind:financeReportsGroup="financeReportsGroup"
                v-bind:financeReportsPocket="financeReportsPocket"
                v-bind:financeReportsYear="financeReportsYear"
                v-bind:rowSelectedCheck="rowSelectedCheck"
                v-bind:invoiceAddingTime="invoiceAddingTime"
                v-bind:tableRef="'invoicedPreviewForAmhInvoice'"
                v-on:tableRefreshTrigger="tableToRefresh"
                v-on:totalRecords="updateTotalRecords"
                v-on:previewSummaries="previewSummaries"
                v-on:selectedInvoiceRows="selectedInvoiceRows"
                v-if="allInputsSelected"
            ></dataTablesComponent>
          </div>
          <div class="column is-full" v-if="invoiceSelectionTab===2 && allInputsSelected">
            <div class="columns is-multiline is-vcentered">
              <div class="column is-3">
                <button class="button is-success is-fullwidth"
                        v-on:click="downloadPreviewedInvoice('download')"><span>Download Preview</span>
                  <span
                      class="icon is-small"><i class="fas fa-download"></i></span></button>
              </div>
              <div class="column is-3">
                <button class="button is-link is-link is-fullwidth" v-on:click="downloadPreviewedInvoice('send')"
                        v-bind:disabled="invoiceUploadedstatus!==0 && invoiceUploadedstatus!==3"
                        v-if="invoiceUploadedstatus!==2">
                  <span>Save & Send</span>
                  <span
                      class="icon is-small"><i class="fas fa-paper-plane"></i></span></button>
              </div>
              <div class="column is-6">
                <div class="columns is-multiline is-vcentered">
                  <div class="column is-full no-padding-cell">
                    <progress class="progress is-success is-small" v-bind:value="progressValue" max="100"
                              v-if="progressValue!==0 && showProgress">{{ progressValue }}%
                    </progress>
                    <progress class="progress is-success is-small" max="100" v-if="progressValue===0 && showProgress">
                      Working
                    </progress>
                  </div>
                  <div class="column is-full no-padding-cell">
                    <span v-if="progressValue!==0 && showProgress">Uploaded {{ progressValue }}%</span>
                    <span v-if="progressValue===0 && showProgress">Preparing Invoice</span>
                    <span v-if="invoiceUploadedstatus===2">The Invoice has been saved and sent.</span>
                    <span v-if="invoiceUploadedstatus===3">An error occurred. Please retry.</span>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="column is-full a4-width" v-if="invoiceSelectionTab===2 && allInputsSelected">
            <div class="columns is-multiline is-vcentered amh-invoice-preview">
              <div class="column is-full">
                <div class="columns is-multiline is-vcentered" id="invoicePreviewForAmhInvoice">
                  <div class="column is-full">
                    <img v-bind:src="`${placeholdersBaseUrl}/profile/placeholder/${filterForPartner}.png`"
                         alt="Partner Logo">
                  </div>
                  <div class="column is-full"></div>
                  <div class="column is-full">
                    Invoice: <span class="is-capitalized">{{ partnerShortName }}</span>-SAFE Program
                  </div>
                  <div class="column is-full"></div>
                  <div class="column is-full">
                    <div class="columns is-multiline is-vcentered is-mobile">
                      <div class="column is-1"></div>
                      <div class="column is-10">
                        <div class="columns is-multiline is-vcentered is-mobile">
                          <div class="column is-4 black-boundary-round">
                            <p class="has-text-left is-capitalized">African Mission Healthcare</p>
                            <p class="has-text-left is-capitalized">P.O. Box 2783</p>
                            <p class="has-text-left is-capitalized">Westville, OH 43086</p>
                          </div>
                          <div class="column is-1"></div>
                          <div class="column is-2 black-boundary-left no-padding-right">
                            <p class="has-text-left is-capitalized">Invoice Number:</p>
                            <p class="has-text-left is-capitalized">Invoice Period:</p>
                            <p class="has-text-left is-capitalized">Date Issued:</p>
                          </div>
                          <div class="column is-5 black-boundary-right no-padding-left">
                            <p class="has-text-right is-capitalized" v-if="generateInvoiceFromServerStatus">
                              {{ generateInvoiceFromServer }}</p>
                            <p class="has-text-right is-capitalized" v-else>Generating...</p>
                            <p class="has-text-right">{{ computeInvoicePeriod }}</p>
                            <p class="has-text-right">{{ computeInvoiceDate }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="column is-1"></div>
                    </div>
                  </div>
                  <div class="column is-full"></div>
                  <div class="column is-full">
                    <div class="columns is-multiline is-vcentered is-mobile">
                      <div class="column is-1"></div>
                      <div class="column is-10">
                        <div class="columns is-multiline is-vcentered table-borders table-heading-border is-mobile">
                          <div class="column is-3 table-heading-cell-border is-capitalized">Patient Name</div>
                          <div class="column is-3 table-heading-cell-border is-capitalized">Inpatient Number</div>
                          <div class="column is-3 table-heading-cell-border is-capitalized">Invoice Number</div>
                          <div class="column is-3 table-heading-cell-border-last is-capitalized">Amount (USD)</div>
                        </div>
                        <div class="columns is-multiline is-vcentered table-borders is-mobile"
                             v-for="(previewInvoiceRow, index) in previewInvoiceRows"
                             v-bind:key="index"
                             v-bind:class="{'table-last-row-border':index===(previewInvoiceRows.length-1)}">
                          <div class="column is-3 table-cell-borders is-capitalized no-padding-cell">{{
                              previewInvoiceRow.patientName
                            }}
                          </div>
                          <div class="column is-3 table-cell-borders no-padding-cell">
                            {{ previewInvoiceRow.inpatientNumber }}
                          </div>
                          <div class="column is-3 table-cell-borders no-padding-cell">{{
                              previewInvoiceRow.invoiceNumber
                            }}
                          </div>
                          <div class="column is-3 table-cell-borders-last no-padding-cell">{{
                              previewInvoiceRow.safeAsk
                            }}
                          </div>
                        </div>
                        <div class="columns is-multiline is-vcentered  is-mobile">
                          <div class="column is-6 is-capitalized"></div>
                          <div class="column is-3 is-capitalized">Total Amount (USD)</div>
                          <div class="column is-3 totals-text">{{ previewInvoiceRowsTotal }}</div>
                        </div>
                      </div>
                      <div class="column is-1"></div>
                    </div>
                  </div>
                  <div class="column is-full"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

.top-align-content {
  align-self: flex-start !important;
}

.amh-invoice-preview {
  border: 2px solid black;
  background-color: white;
}

.black-boundary-round {
  border: 3px solid black;
}

.black-boundary-left {
  border-top: 3px solid black;
  border-left: 3px solid black;
  border-bottom: 3px solid black;
}

.black-boundary-right {
  border-top: 3px solid black;
  border-right: 3px solid black;
  border-bottom: 3px solid black;
}

.table-heading-border {
  border-top: 2px solid black;
}

.table-heading-cell-border {
  border-bottom: 2px solid black;
  border-right: 2px solid black;
}

.table-heading-cell-border-last {
  border-bottom: 2px solid black;
}

.table-borders {
  border-left: 2px solid black;
  border-right: 2px solid black;
}

.table-cell-borders {
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.table-cell-borders-last {
  border-bottom: 1px solid black;
}

.table-last-row-border {
  border-bottom: 2px solid black;
}

.totals-text {
  text-decoration-line: underline;
  text-decoration-style: double;
  text-underline-offset: 5px;
}

.a4-width {
  min-width: 1000px !important;
}

.a4-width-container {
  overflow: scroll;
}

.no-padding-cell {
  padding: 0px !important;
}

.no-padding-right {
  padding-right: 0px !important;
}

.no-padding-left {
  padding-left: 0px !important;
}

.preview-requirements {
  margin-right: 20px;
}

</style>